module.exports = __webpack_public_path__ + "media/images/emblems/Balgach_coats_of_arms-a4f9f46ecc1f9089e61e6e93119caee5.png";